/*@ngInject*/
const TermsAndConditionsController = function ($rootScope, $scope, options, attachmentMediator, attachmentUtil, localization, coreMediator, coreConstant) {

    localization.getTranslations().then(function (translations) {

        $scope.title = _.get(translations, 'termsAndCondition.title');
        $scope.okButton = _.get(translations, 'termsAndCondition.confirm');
        $scope.cancelButton = _.get(translations, 'termsAndCondition.cancel');
        $scope.isInModal = true;

        $scope.viewModel = {
            attachmentMimeType: options.configuredFile.mimeType,
            attachmentName: options.configuredFile.fileName,
            configuredFileId: options.configuredFile.id
        };

        $scope.onConfirm = function () {
            coreMediator.updateUserPreferences('general.copyrightLicense.accepted', 'true');
            $scope.$close();
        };

        $scope.onCancel = function () {
            coreMediator.updateUserPreferences('general.copyrightLicense.accepted', 'false');
            coreMediator.logout();
            $scope.$dismiss();
        };
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umLanding')
    .controller('termsAndConditionsController', TermsAndConditionsController);
